import ClassicBike from "./classic-bike";
import ClassicBus from "./classic-bus";
import ClassicCar from "./classic-car";
import ClassicFerry from "./classic-ferry";
import ClassicGondola from "./classic-gondola";
import ClassicMicromobility from "./classic-micromobility";
import ClassicTram from "./classic-tram";
import ClassicWalk from "./classic-walk";

export {
  ClassicBike,
  ClassicBus,
  ClassicCar,
  ClassicFerry,
  ClassicGondola,
  ClassicMicromobility,
  ClassicTram,
  ClassicWalk
};
